export const DEFAULT_LIMIT = 25;
export const DEFAULT_OFFSET = 0;
export const DEFAULT_ARTICLES_LIMIT = 15;
export const DEFAULT_TAGS_LIMIT = 21;
export const DEFAULT_COMMENTS_LIMIT = 25;
export const DEFAULT_COURSES_LIMIT = 20;
